
export class MenuClickContext {
    page: string;    
    currentPageIsValid: boolean;
    currentPageDataChanged: boolean = false;
}

export interface HttpResults
 {
    isSuccess: boolean;
    responseText: string;
    isInternalUser: boolean;
    role: string
    agencyCode: string
    isEndorsementActive: boolean;
    userData: any;
}

export interface workInProgress
{
    id: string;
    nameInsured: string;  
    dotNumber: number;
    referenceNumber: string;
    effectiveDate: string;
    page: string;
    status: string;
    tags: string;
    submissionTimeStamp: string;
    agentName: string;
    aAgencyCode: string;
    clientId: string;
    policyNumber: string;
    email: string;
    proceedAs: string;
}

export const WorkInProgressHelper = {
    addSearchTags(list: workInProgress[]): workInProgress[] {
        return list.map(item => {
            item.tags = item.status === 'Indication' ? 'No Formal Quote Requested' : item.status;
            return item;
        });
    }
}